import { render, staticRenderFns } from "./template-prize.vue?vue&type=template&id=b25ed57a&scoped=true&"
import script from "./template-prize.vue?vue&type=script&lang=js&"
export * from "./template-prize.vue?vue&type=script&lang=js&"
import style0 from "./template-prize.vue?vue&type=style&index=0&id=b25ed57a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b25ed57a",
  null
  
)

export default component.exports